class SessionData {
    mydrLoaded;
    mydrInstance;
    constructor() {
        this.mydrLoaded = false;
        this.mydrInstance = null;
    }

    setMydrLoaded() {
        this.mydrLoaded = true;
    }

    isMydrLoaded() {
        return this.mydrLoaded;
    }

    setMydrInstance(mydrInstance) {
        this.mydrInstance = mydrInstance;
    }

    getMydrInstance() {
        return this.mydrInstance;
    }
}

export default SessionData;
